import { useEffect } from 'react'

import { pushEvent } from '@/lib/analytics'
import type { AnalyticsEntity } from '@/lib/analytics'

export function useTrackCreateStarted(entity: AnalyticsEntity): void {
  useEffect(() => {
    pushEvent('create_started', { entity })
  }, [entity])
}
